module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-block"
  }, _vm._l((_vm.menus), function(item, index) {
    return _c('blockquote', {
      key: index,
      staticClass: "layui-elem-quote layui-quote-nm left-block",
      on: {
        "click": function($event) {
          _vm.$options.filters.openRoute(item.menuUrl)
        }
      }
    }, [(item.menuUrl && item.menuUrl.indexOf('/') == 0) ? _c('router-link', {
      attrs: {
        "to": {
          path: item.menuUrl
        }
      }
    }, [_vm._v(_vm._s(item.menuName))]) : _c('a', {
      attrs: {
        "href": item.menuUrl,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(item.menuName))])], 1)
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-162badb4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/home.vue
// module id = 309
// module chunks = 2